import { render, staticRenderFns } from "./VacancyPresetsCategories.vue?vue&type=template&id=4d1cbd21&scoped=true&"
import script from "./VacancyPresetsCategories.vue?vue&type=script&lang=js&"
export * from "./VacancyPresetsCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1cbd21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
